module.exports = __webpack_public_path__ + "img/34.17661b11.jpg";